<article *ngIf="selectedVideo"
         class="w-full flex flex-column">
  <video #videoPlayer
         muted
         autoplay
         [src]="selectedVideo.url"
         type="video/mp4"
         (ended)="onVideoEnded()"
         (click)="toggleVideo()"
         (loadeddata)="playVideo()">
    Tu navegador no soporta la etiqueta de video.
  </video>
</article>